import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

export type NoticeTone = "info" | "success" | "attention" | "error" | "joy";

const ICON: Record<NoticeTone, IconName> = { info: "info", success: "circle-check", attention: "triangle-alert", error: "circle-alert", joy: "sparkles" };
const KLASSE: Record<NoticeTone, string> = { info: "petrol", success: "success", attention: "attention", error: "danger", joy: "joy" };

export interface NoticeProps {
  tone?: NoticeTone;
  title?: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  icon?: IconName;
  className?: string;
}

/** Hinweis im Fluss der Seite. `attention` für Entscheidungen, `error` nur wenn etwas schiefging; beide sagen den nächsten Schritt. */
export function Notice({ tone = "info", title, children, action, icon, className }: NoticeProps) {
  return (
    <div className={["rg-notice", `rg-notice--${KLASSE[tone]}`, className].filter(Boolean).join(" ")} role={tone === "error" ? "alert" : "status"}>
      <Icon name={icon ?? ICON[tone]} size={22} className="rg-notice__icon" />
      <div className="rg-notice__body">
        {title ? <div className="rg-notice__title">{title}</div> : null}
        {children ? <div className="rg-notice__text">{children}</div> : null}
      </div>
      {action ? <div className="rg-notice__action">{action}</div> : null}
    </div>
  );
}
